// extracted by mini-css-extract-plugin
export default {"tooltip":"GV-z","arrow":"HV-z"};